var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          key: _vm.tableKey,
          ref: "elTable",
          staticClass: "table-card",
          attrs: { data: _vm.tableData, height: _vm.tableHeight, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", type: "selection", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.ind"),
              align: "center",
              width: "60px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.currentColumns, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                align: item.fixed,
                label: item.label,
                prop: item.prop,
                "show-overflow-tooltip": true,
                "min-width": item.width,
                "class-name": "ellipsis",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "businessType"
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row[item.prop] === 0
                                      ? _vm.$t(
                                          "basicData.CourierSystemBusiness"
                                        )
                                      : scope.row[item.prop] === 1
                                      ? _vm.$t(
                                          "basicData.CollectionSystemBusiness"
                                        )
                                      : ""
                                  ) +
                                  " "
                              ),
                            ])
                          : item.prop === "cargoType"
                          ? _c("div", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (_vm.CARGO_TYPE[scope.row[item.prop]] &&
                                      _vm.CARGO_TYPE[scope.row[item.prop]]
                                        .name) ||
                                      ""
                                  )
                                ),
                              ]),
                            ])
                          : item.prop === "collectType"
                          ? _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    scope.row[item.prop] === 1
                                      ? _vm.$t("collectionCenter.dropOff")
                                      : scope.row[item.prop] === 2
                                      ? _vm.$t("collectionCenter.doorPickUp")
                                      : ""
                                  ) +
                                  " "
                              ),
                            ])
                          : _c("div", [_vm._v(_vm._s(scope.row[item.prop]))]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm._l(_vm.getCurrentColumns, function (item, ind) {
            return _c("el-table-column", {
              key: ind + 100,
              attrs: {
                align: item.fixed,
                label: item.label,
                prop: item.prop,
                "show-overflow-tooltip": true,
                "min-width": item.width,
                "class-name": "ellipsis",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("div", [_vm._v(_vm._s(scope.row[item.prop]))])]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _vm.isWithdraw
            ? [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("receivablePayable.ReconciliationStatus"),
                    prop: "isGenReceipt",
                    width: "140",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.isGenReceipt
                                    ? _vm.$t("receivablePayable.reconciled")
                                    : _vm.$t("receivablePayable.pending")
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1463270020
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("basicData.operate"),
                    align: "center",
                    width: "140",
                    fixed: "right",
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-popconfirm",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "receivablePayable.AreYouSureYouWantToWithdraw"
                                  ),
                                },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.recall(scope.row)
                                  },
                                },
                              },
                              [
                                !scope.row.isGenReceipt
                                  ? _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permit",
                                            rawName: "v-permit:remove",
                                            value:
                                              "btn:receivableManagementSite:toExamine:recall",
                                            expression:
                                              "'btn:receivableManagementSite:toExamine:recall'",
                                            arg: "remove",
                                          },
                                        ],
                                        attrs: {
                                          slot: "reference",
                                          type: "danger",
                                          size: "mini",
                                        },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("receivablePayable.withdraw")
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    306839641
                  ),
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }